import api from "../../services/activity";
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types("activity");
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({}, "Activity");
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations,
	};
}
